import {JSXElementConstructor, ReactElement, ReactNode} from 'react';

import {Spacing} from 'styles/Base';

export interface MarginProps {
  margin?: string;
  marginBottom?: Spacing;
  marginLeft?: Spacing;
  marginRight?: Spacing;
  marginTop?: Spacing;
}

export interface PaddingProps {
  padding?: string;
  paddingBottom?: Spacing;
  paddingLeft?: Spacing;
  paddingRight?: Spacing;
  paddingTop?: Spacing;
}

export const generateMargins = (props: MarginProps) => `
  ${props.margin ? `margin: ${props.margin};` : ''}
  ${props.marginTop ? `margin-top: ${props.marginTop};` : ''}
  ${props.marginRight ? `margin-right: ${props.marginRight};` : ''}
  ${props.marginBottom ? `margin-bottom: ${props.marginBottom};` : ''}
  ${props.marginLeft ? `margin-left: ${props.marginLeft};` : ''}
`;

export const generatePadding = (props: PaddingProps) => `
  ${props.padding ? `padding: ${props.padding};` : ''}
  ${props.paddingTop ? `padding-top: ${props.paddingTop};` : ''}
  ${props.paddingRight ? `padding-right: ${props.paddingRight};` : ''}
  ${props.paddingBottom ? `padding-bottom: ${props.paddingBottom};` : ''}
  ${props.paddingLeft ? `padding-left: ${props.paddingLeft};` : ''}
`;

const isChildString = (child: ReactNode) =>
  !!child && (typeof child === 'string' || typeof (child as ReactElement)?.type === 'string');

export const isChildNull = (child: ReactNode) => {
  if (!child) {
    return true;
  }

  if (isChildString(false)) {
    return false;
  }

  const childElement = child as ReactElement<any, JSXElementConstructor<any>>;

  const childType = childElement.type as (props: any) => ReactElement<any, any> | null;
  return !childType || !childType(childElement.props);
};
